import React, { useContext, useEffect, useRef } from 'react'
import './Home.css'
import { AuthContext } from '../../context/AuthContext'
import { arrayRemove, doc, updateDoc } from 'firebase/firestore'
import { db } from '../../config'
import { ChatContext } from '../../context/ChatContext'

const Message = ({ message }) => {
  const { curUser } = useContext(AuthContext)
  const { data } = useContext(ChatContext)

  const divName =
    message.sender === curUser.displayName ? 'messageUser' : 'message'
  const ref = useRef()

  useEffect(() => {
    ref.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start',
    })
  }, [message])

  // useEffect(() => {
  //   if (message.sender !== curUser.displayName) {
  //     var notification = new Notification('hi there')
  //   }
  // })

  const handleUnsend = async () => {
    if (message.sender !== curUser.displayName) return

    var check = window.confirm('Are you sure to unsend this message?')

    if (check) {
      if (message.img) {
        await updateDoc(doc(db, 'groups', data.groupId), {
          message: arrayRemove({
            id: message.id,
            text: message.text,
            sender: message.sender,
            date: message.date,
            img: message.img,
          }),
        })
      } else {
        await updateDoc(doc(db, 'groups', data.groupId), {
          message: arrayRemove({
            id: message.id,
            text: message.text,
            sender: message.sender,
            date: message.date,
          }),
        })
      }
    }
  }

  return (
    <div ref={ref} className={divName}>
      <div className="messageInfo">
        <span>{message.sender}</span>
      </div>
      <div className="messageContent" onClick={handleUnsend}>
        {message.text !== '' && <p className="singleMessage">{message.text}</p>}
        {message.img && <img src={message.img} alt="" />}
      </div>
    </div>
  )
}

export default Message
